import { requestApiClient, requestApiUser } from "../functions";

export const ProductsQueriesUser = {
    create: async (data) => {
        const res = await requestApiUser('/products', 'POST', data);
        return res;
    },
    findAll: async () => {
        const res = await requestApiUser('/products', 'GET');
        return res;
    },
    findById: async (id) => {
        const res = await requestApiUser(`/products/${id}`, 'GET');
        return res;
    },
    update: async (id, data) => {
        const res = await requestApiUser(`/products/${id}`, 'PUT', data);
        return res;
    },
    delete: async (id) => {
        const res = await requestApiUser(`/products/${id}`, 'DELETE');
        return res;
    },
    findAllWithDetails: async () => {
        const res = await requestApiUser('/products/all/with-details', 'GET');
        return res;
    },
    findBySearchWithDetails: async (search) => {
        const res = await requestApiUser(`/products/search/${search}`, 'GET');
        return res;
    },
    findByCategoriesFilter: async (categories_ids) => {
        const res = await requestApiUser(`/products/categories/search/${categories_ids}`, 'GET');
        return res;
    },
};

export const ProductsQueriesClient = {
    findAll: async () => {
        const res = await requestApiClient('/products', 'GET');
        return res;
    },
    findById: async (id) => {
        const res = await requestApiClient(`/products/${id}`, 'GET');
        return res;
    },
    findAllWithDetails: async () => {
        const res = await requestApiClient('/products/all/with-details', 'GET');
        return res;
    },
    findBySearchWithDetails: async (search) => {
        const res = await requestApiClient(`/products/search/${search}`, 'GET');
        return res;
    },
    findByCategoriesFilter: async (categories_ids) => {
        const res = await requestApiClient(`/products/categories/search/${categories_ids}`, 'GET');
        return res;
    },
};